// 充值订单列表
export default {
    heard_title: "Item Order List",
    fl_search: "Enter search:",
    fp_search: "Mobile phone number/product name/order number",
    fl_submitTime: "Submit Time:",
    fp_startTime: "Pick a start date",
    fp_endTime: "Pick an end date",
    btn_recharge: "Recharge",
    // 表格
    tl_no: "Order number",
    tl_orderTime: "Submit Time",
    tl_mobile: "Mobile number",
    tl_amount: "Order Amount",
    tl_rewardAmount: "Reward Amount",
    tl_balance: "Balance",
    tl_paymentModel: "Payment Method",
    tl_channel: "Order Source",
    btn_print: "Print receipt",

    // 提示
    sm_print: "Print successful",
    rm_print: "Print failed",

    remove_resHint: "Remove",
    sm_resHint: "Success",
    rm_resHint: "Failed"
};
